import styled from 'styled-components';
import Input from '../../../../../../common/components/Input';

export const StyledInput = styled(Input)`
  width: 290px;
`;
